const GetTopCams = `query TopCams($type:TopCamCategorieFilter!,$online:Boolean){topCams(type:$type,online:$online){id name profileLink online onlineVideocall age previewPicture avatarPicture spokenLanguages pinnedCount ratingCount satisfactionRate rankingPointsVideoCall videocallPrice{singleC2CChat{value currency symbol}}}}`;

export { GetTopCams };
